import Test from './pages/Test.vue';

export default {
  'wexo-test': Test,
};
